export default {
  weekoffpolicyname: {
    header: 'Weekly-off Name & Description',
    headercss: 'vmHeader',
    subheader: 'Weekly-off Name',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  description: {
    header: '',
    headercss: 'vmHeader',
    subheader: 'Brief description about this Weekly-off',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  isaccumulation: {
    dependent: '',
    header: 'Accumulation',
    headercss: 'vmHeader',
    subheader: 'Allow accumulation of unused weekly offs?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },

  accumulationtypeid: [{
    1: {
      dependent: 'isaccumulation',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Accumulation Type',
      subheadercss: 'vmSubHeader',
      values: 'Unlimited Accumulation',
    },
    2: {
      dependent: 'isaccumulation',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Accumulation Type',
      subheadercss: 'vmSubHeader',
      values: 'Limited Accumulation',
    },
  }],
  accumulationlimit: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Limit to',
    subheadercss: 'vmSubHeader',
    values: '<val> Number of weekly offs',
  },

  refreshtypeid: [{
    1: {
      dependent: 'isaccumulation',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Refresh accumulated weekly offs?',
      subheadercss: 'vmSubHeader',
      values: 'Monthly refresh of accumulated weekly off counts',
    },
    2: {
      dependent: 'isaccumulation',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Refresh accumulated weekly offs?',
      subheadercss: 'vmSubHeader',
      values: 'Yearly refresh of accumulated weekly off counts',
    },
  }],
  weekoffdata: [
    {
      weekday: {
        dependent: '',
        header: 'Define',
        headercss: 'vmHeader',
        subheader: 'Week Day',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      Weeklist: {
        dependent: '',
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
    },
    {
      weekday: {
        dependent: '',
        header: '',
        headercss: 'vmHeader',
        subheader: 'Week Day',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
      Weeklist: {
        dependent: '',
        header: '',
        headercss: 'vmHeader',
        subheader: '',
        subheadercss: 'vmSubHeader',
        values: '<val>',
      },
    },
  ],

};
